import { RequestCreationSuccess } from "@features/cx/shared/components/RequestCreationSuccess";
import { useLocation, useNavigate } from "react-router-dom";

function ReconnectionSuccessPage() {
  const navigate = useNavigate();
  // The state contains the merged data from your navigation
  const { formData, ...apiResponse } = useLocation().state || {};

  const requestData = {
    ...apiResponse,
    formData: formData,
  };
  if (!requestData) {
    return <div>No request data found</div>;
  }
  console.log("requestData at receipt", requestData);

  return (
    <RequestCreationSuccess
      requestData={requestData}
      requestType="reconnection"
      onReturnToDashboard={() => navigate("/cx/reconnections")}
      onAddNewRequest={() => navigate("/cx/reconnections/create")}
    />
  );
}

export default ReconnectionSuccessPage;
